import React, {FC, useState, useEffect, useRef} from "react"

import {FormattedMessage, injectIntl, InjectIntl} from "@irati/utils/lang"

import Icon, {IconTypes} from "../Icon"
import {useTheme} from "../global/useTheme"
import Flex from "../Flex"
import {H6, Label} from "../Typography"
import {DropdownOptionsWrapper, StyledFocusOnKeyboard, StyledRouterLink} from "./styled"

interface DropdownOption {
  text: string
  icon?: string
  link?: string
  app?: string
  onClick?: () => void
  id?: string
}

interface Props extends InjectIntl {
  title: string
  options: DropdownOption[]
  isRightAligned?: boolean
}

const DropdownNavigation: FC<Props> = (props) => {
  const [isMenuDisplayed, setIsMenuDisplayed] = useState<boolean>(false)
  const containerRef = useRef<any>()
  const optionsRef = useRef<any>()
  const {title, options, isRightAligned} = props

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick, true)
    return () => {
      document.removeEventListener("click", handleOutsideClick, true)
    }
  }, [])

  const toggle = () => {
    setIsMenuDisplayed((current) => !current)
  }

  const handleOutsideClick = ({target}) => {
    const isClickingOutsideContainer = containerRef.current && !containerRef.current.contains(target)
    const isClickingOutsideOptions = optionsRef.current && !optionsRef.current.contains(target)
    if (isClickingOutsideContainer && isClickingOutsideOptions) {
      toggle()
    }
  }

  const theme = useTheme()

  return (
    <Flex direction="column" alignItems={isRightAligned ? "flex-end" : "flex-start"} position="relative">
      <StyledFocusOnKeyboard onClick={toggle}>
        <div ref={containerRef}>
          <H6 color={theme.colors.primary2}>
            <FormattedMessage id={title} />
            <Icon
              color={theme.colors.primary2}
              marginLeft={0.5}
              size={12}
              icon={isMenuDisplayed ? IconTypes.chevronUp : IconTypes.chevronDown}
            />
          </H6>
        </div>
      </StyledFocusOnKeyboard>
      {isMenuDisplayed && (
        <DropdownOptionsWrapper ref={optionsRef} onClick={toggle}>
          <>
            {options.map((dropdownOption: DropdownOption, i) => {
              const {text, icon, link, onClick = () => {}, app, id} = dropdownOption
              if (link) {
                return (
                  <StyledRouterLink id={id} plain app={app} key={`dropdownNavOption-${i}`} to={link} onClick={onClick}>
                    <Label>
                      <FormattedMessage id={text} />
                      {icon && <Icon marginLeft={0.5} size={12} icon={icon} />}
                    </Label>
                  </StyledRouterLink>
                )
              }
              return (
                <div id={id} key={`dropdownNavOption-${i}`} onClick={onClick}>
                  <Label>
                    <FormattedMessage id={text} />
                    {icon && <Icon marginLeft={0.5} size={10} icon={icon} />}
                  </Label>
                </div>
              )
            })}
          </>
        </DropdownOptionsWrapper>
      )}
    </Flex>
  )
}

export default injectIntl(DropdownNavigation)
